export default "__VITE_ASSET__DGZhzseD__"